"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgSpacesDataStatusHeaderOutline = void 0;
var React = require("react");
function SvgSpacesDataStatusHeaderOutline(props) {
    return (React.createElement("svg", __assign({ id: "Spaces_Data_Status_Header_Outline_svg__Layer_1", x: 0, y: 0, width: 15, height: 15, xmlSpace: "preserve" }, props),
        React.createElement("style", null, ".Spaces_Data_Status_Header_Outline_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#666}"),
        React.createElement("path", { id: "Spaces_Data_Status_Header_Outline_svg__Line", className: "Spaces_Data_Status_Header_Outline_svg__st0", d: "M7 4h1v5H7z" }),
        React.createElement("path", { id: "Spaces_Data_Status_Header_Outline_svg__Dot_2_", className: "Spaces_Data_Status_Header_Outline_svg__st0", d: "M7 10h1v1H7z" }),
        React.createElement("path", { id: "Spaces_Data_Status_Header_Outline_svg__Circle", d: "M7.5 1C3.9 1 1 3.9 1 7.5S3.9 14 7.5 14 14 11.1 14 7.5 11.1 1 7.5 1zm0 12C4.5 13 2 10.5 2 7.5S4.5 2 7.5 2 13 4.5 13 7.5 10.5 13 7.5 13z", fillRule: "evenodd", clipRule: "evenodd", fill: "#666766" })));
}
exports.SvgSpacesDataStatusHeaderOutline = SvgSpacesDataStatusHeaderOutline;
//# sourceMappingURL=SpacesDataStatusHeaderOutline.js.map